module.exports = __webpack_public_path__ + "img/inetlogo_1.00a7bc6a.png";